import { css } from 'linaria';

export const stages = css`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  column-gap: 56px;

  @media (--only-desktop) {
    column-gap: 26px;
  }

  @media (--to-desktop) {
    align-items: flex-start;
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const stage = css`
  display: flex;
  column-gap: 12px;

  @media (--only-desktop) {
    column-gap: 10px;
  }

  @media (--to-desktop) {
    align-items: center;
  }
`;

export const stageIcon = css`
  @media (--only-tablet) {
    width: 38px;
    height: 38px;
  }

  @media (--only-mobile) {
    width: 32px;
    height: 32px;
  }
`;
